
export const CheckEmail = async ( firebase, email ) => {
  const methods = await firebase
    .auth()
    .fetchSignInMethodsForEmail( email )

  return methods.length !== 0
}

export default CheckEmail